/* global hextom_fsb */

window.ox = window.ox || {};

window.ox.ajaxcart = {
    reloadTimer: null,

    open: function () {
        window.ox.ajaxcart.load(function () {
            jQuery('#ajax-cart-sidebar').addClass('open');
            if (jQuery('img[src="//support.organixx.com/scripts/file.php?view=Y&file=c34c691efd368aa71bef3bcfd7106836"]').length) {
                jQuery('img[src="//support.organixx.com/scripts/file.php?view=Y&file=c34c691efd368aa71bef3bcfd7106836"]').animate({'right': '370px'}, 200);
            }
            if (jQuery('img[src="//support.organixx.com/scripts/file.php?view=Y&file=b783c7ed1a7b20e7165dccb22d579b99"]').length) {
                jQuery('img[src="//support.organixx.com/scripts/file.php?view=Y&file=b783c7ed1a7b20e7165dccb22d579b99"]').animate({'right': '370px'}, 200);
            }
            $('.checkout-link').attr('disabled', true);
            ox.upsells.loadCart();
        });
    },

    load: function (callback) {
        var after = function ()
        {
            jQuery('#ajax-cart-sidebar .cart-sidebar-container').load('/cart?view=ajax-sidebar', function ()
            {
                jQuery('.ajax-cart-loader-overlay').hide();
                if (typeof callback === 'function')
                {
                    callback();
                }
            });
        };
        ox.shoplift.cart.check(after, after);
    },

    close: function () {
        jQuery('#ajax-cart-sidebar').removeClass('open');
        if (jQuery('img[src="//support.organixx.com/scripts/file.php?view=Y&file=c34c691efd368aa71bef3bcfd7106836"]').length) {
            jQuery('img[src="//support.organixx.com/scripts/file.php?view=Y&file=c34c691efd368aa71bef3bcfd7106836"]').animate({'right': '0'}, 200);
        }
        if (jQuery('img[src="//support.organixx.com/scripts/file.php?view=Y&file=b783c7ed1a7b20e7165dccb22d579b99"]').length) {
            jQuery('img[src="//support.organixx.com/scripts/file.php?view=Y&file=b783c7ed1a7b20e7165dccb22d579b99"]').animate({'right': '0'}, 200);
        }
    },

    // Register jQuery .on listeners for ajax cart itself
    // For page/global listeners see document ready block below
    registerEventListeners: function () {
        var $cart = jQuery('#ajax-cart-sidebar');

        $cart.on('click', 'a', function (e) {
            window.ox.ajaxcart.interceptLinkClick($(this), e);
        });

        $cart.on('click', '.ajax-close-cart', function (e) {
            e.preventDefault();
            window.ox.ajaxcart.close();
        });

        // if click outside element and it has the class .open, remove the class
        $cart.on('mouseup', function (e) {
            if ($cart.hasClass('open')) {
                var el = jQuery(e.target);
                if (el.parents('.cart-sidebar-container').length == 0) {
                    e.preventDefault();
                    window.ox.ajaxcart.close();
                }
            }
        });

        $cart.on('change', 'input', function (e) {
            window.clearTimeout(window.ox.ajaxcart.loadTimer);
            var $input = $(this);
            if ($input.val() < 1) {
                $input.val(1);
                return false;
            }
            jQuery('.btn.carthook_checkout').attr('disabled', 'disabled');
            window.ox.ajaxcart.loadTimer = window.setTimeout(function () {
                jQuery('.ajax-cart-loader-overlay').show();
                window.ox.ajaxcart.updateQuantity($input);
            }, 1500);
        });

        $cart.on('keyup', 'input', function (e) {
            window.clearTimeout(window.ox.ajaxcart.loadTimer);
            var line = $(this).attr('data-line');
            var $input = $(this);
            if ($input.val() < 1) {
                return false;
            }
            window.ox.ajaxcart.loadTimer = window.setTimeout(function () {
                jQuery('.ajax-cart-loader-overlay').show();
                window.ox.ajaxcart.updateQuantity($input, function () {
                    jQuery('input[data-line=' + line + ']').focus();
                });
            }, 3000);
        });
    },

    interceptLinkClick: function ($el, event) {
        if ($el.attr('href').match(/^\/cart/)) {
            event.preventDefault();
            jQuery.get($el.attr('href'), function () {
                window.ox.ajaxcart.load();
                window.ox.ajaxcart.updateCart();
            });
        }
    },

    updateQuantity: function ($input, callback)
    {
        jQuery.ajax({
            method: 'POST',
            url: '/cart/change.js',
            data: {
                quantity: $input.val(),
                line: $input.attr('data-line')
            },
            dataType: 'json',
            success: function (data)
            {
                window.ox.ajaxcart.load(function ()
                {
                    $.ajax({
                        type: 'GET',
                        url: '/cart.js',
                        dataType: 'json',
                        success: function (response)
                        {
                            $('.cart-count').text(response.item_count);
                            ox.upsells.triggerCartLoaded(response);
                        },
                        error: function (error)
                        {
                            console.log('Something went wrong', error);
                        }
                    });
                    if (typeof callback === 'function')
                    {
                        callback();
                    }
                });
            }
        });
    },

    processDiscounts: function (callback) {
        jQuery('.ajax-cart-loader-overlay').show();

        var tier1 = /^(.+) 3-5$/;
        var tier2 = /^(.+) 6\+$/;

        var newProducts = {};
        var newBaseProducts = {};
        var newCartProducts = {};
        var newCartUpdates = {};

        // Loop through the cart items and add their products to the products list along with the quantity.
        // For each cartItem
        jQuery.each(window.ox.cartItems, function (itemId, item) {
            var product = window.ox.cartProducts[item.product_id];

            //    Determine if the product has multiple variants, or just one.
            if (!product || product.variants.length > 1) {
                return true; //continue
            }

            newProducts[product.handle] = product;
            newProducts[product.handle].quantity = item.quantity;
            if (product.hasOwnProperty('subscriptions') && product.subscriptions.hasOwnProperty('original_handle')) {
                newProducts[product.handle].nonSubscriptionProduct = product.subscriptions.original_handle;
                if (!newProducts.hasOwnProperty(product.subscriptions.original_handle)) {
                    newProducts[product.subscriptions.original_handle] = {
                        fetch: true,
                        subscriptionProduct: product.handle
                    };
                }
            }
        });


        // Process each product in the products list to get their product data if it is missing.
        var deferredCalls = [];
        jQuery.each(newProducts, function (handle, product) {
            if (product.hasOwnProperty('fetch') && product.fetch === true) {
                var call = jQuery.ajax({url: '/products/' + handle, method: 'GET', dataType: 'json'}).then(function (productData) {
                    if (newProducts.hasOwnProperty(productData.product.handle) && newProducts[productData.product.handle].hasOwnProperty('subscriptionProduct')) {
                        productData.product.subscriptionProduct = newProducts[productData.product.handle].subscriptionProduct;
                    }
                    newProducts[productData.product.handle] = productData.product;
                    if (typeof productData.product.tags === 'string') {
                        newProducts[productData.product.handle].tags = productData.product.tags.split(', ');
                    }
                });
                deferredCalls.push(call);
            }
        });

        // Function to parse the product and return tier information.
        var parseProduct = function (product) {
            var tags = {};
            var buildsetV1TagRegex = /^buildset-v1$/i;
            var buildsetQtyBreakTagRegex = /^buildset-qty-(\d+)-(.+)$/i;
            var buildsetCanonicalTagRegex = /^buildset-canonical-(.+)$/i;
            var buildsetCurrentQtyTagRegex = /^buildset-current-qty-(\d+)$/i;
            var buildsetUseQuantitiesRegex = /^buildset-v1-use-quantities$/i;
            var productInfo = {};
            jQuery.each(product.tags, function (tagId, tag) {
                var match = null;
                if (buildsetV1TagRegex.test(tag)) {
                    tags['buildset-v1'] = true;
                } else if ((match = buildsetQtyBreakTagRegex.exec(tag)) !== null) {
                    if (!tags.hasOwnProperty('buildset-qty')) {
                        tags['buildset-qty'] = {};
                    }

                    tags['buildset-qty'][match[1]] = match[2];
                } else if ((match = buildsetCanonicalTagRegex.exec(tag)) !== null) {
                    tags['buildset-canonical'] = match[1];
                } else if ((match = buildsetCurrentQtyTagRegex.exec(tag)) !== null) {
                    tags['buildset-current-qty'] = match[1];
                } else if ((match = buildsetUseQuantitiesRegex.exec(tag)) !== null) {
                    tags['buildset-v1-use-quantities'] = true;
                }
            });

            productInfo.process = tags.hasOwnProperty('buildset-v1-use-quantities');

            var hasBaseProduct = false;
            if (tags.hasOwnProperty('buildset-canonical')) {
                productInfo.baseProduct = tags['buildset-canonical'];
                productInfo.tierQuantity = tags['buildset-current-qty'];
                hasBaseProduct = true;
            }

            //    If it has a buildset-v1 tag, this is a base product so set it up in the array and include the qty and a reference to the cart item.
            if (tags.hasOwnProperty('buildset-v1')) {
                productInfo.baseProduct = null;
                productInfo.tiers = {};
                jQuery.each(tags['buildset-qty'], function (qty, handle) {
                    productInfo.tiers[qty] = handle;
                });
                hasBaseProduct = true;
            }

            productInfo.hasBaseProduct = hasBaseProduct;
            if (!hasBaseProduct) {
                productInfo.hasBaseProduct = false;
            }

            return productInfo;
        };

        jQuery.when.apply(jQuery, deferredCalls).then(function () {
            // Process each non-subscription product in the products list to find their base product.
            jQuery.each(newProducts, function (handle, product) {
                //    - if the product is not a subscription product, check the product data for a canonical tag - if it has a canonical tag, set the base product data for the product to the handle from the canonical tag. If there is no
                //      canonical tag, set the base product data for the product to null.
                if (!product.hasOwnProperty('nonSubscriptionProduct')) {
                    var productInfo = parseProduct(product);
                    if (productInfo.hasBaseProduct) {
                        newProducts[handle].baseProduct = productInfo.baseProduct;
                    } else {
                        delete newProducts[handle];
                    }
                }
            });

            // Process each subscription product in the products list to find their base product.
            jQuery.each(newProducts, function (handle, product) {
                //    - if the product is a subscription product, get the base product from the non-subscription product handle.
                if (product.hasOwnProperty('nonSubscriptionProduct')) {
                    // Check that the non-subscription product handle exists - if it doesn't, then it's not a product we are supposed to process for tiered discount.
                    if (!newProducts.hasOwnProperty(product.nonSubscriptionProduct)) {
                        delete newProducts[handle];
                    } else {
                        // Update the base product for the subscription product.
                        if (newProducts[product.nonSubscriptionProduct].baseProduct === null) {
                            newProducts[handle].baseProduct = product.nonSubscriptionProduct;
                        } else {
                            newProducts[handle].baseProduct = newProducts[product.nonSubscriptionProduct].baseProduct;
                        }
                    }
                }
            });

            // Loop through all the products and create the list of base products based on the base product data on each product.
            // Also sum up the quantity of each base product based on the cart item data.
            jQuery.each(newProducts, function (handle, product) {
                var baseProduct = product.baseProduct;
                if (baseProduct === null) {
                    baseProduct = handle;
                }

                if (!newBaseProducts.hasOwnProperty(baseProduct)) {
                    newBaseProducts[baseProduct] = {
                        quantity: 0,
                        subscriptionQuantity: 0
                    };
                }

                if (product.hasOwnProperty('quantity')) {
                    if (product.hasOwnProperty('nonSubscriptionProduct')) {
                        newBaseProducts[baseProduct].subscriptionQuantity += product.quantity;
                    } else {
                        newBaseProducts[baseProduct].quantity += product.quantity;
                    }
                }
            });

            // Loop through the base products list, and for each base product that doesn't have product data in the products list,
            // use an ajax call to get the product data.
            deferredCalls = [];
            jQuery.each(newBaseProducts, function (handle, data) {
                if (!newProducts.hasOwnProperty(handle) || newProducts[handle].fetch === true) {
                    var call = jQuery.ajax({url: '/products/' + handle, method: 'GET', dataType: 'json'}).then(function (productData) {
                        if (newProducts.hasOwnProperty(productData.product.handle) && newProducts[productData.product.handle].hasOwnProperty('subscriptionProduct')) {
                            productData.product.subscriptionProduct = newProducts[productData.product.handle].subscriptionProduct;
                        }
                        newProducts[productData.product.handle] = productData.product;
                        if (typeof productData.product.tags === 'string') {
                            newProducts[productData.product.handle].tags = productData.product.tags.split(', ');
                        }
                    });
                    deferredCalls.push(call);
                }
            });

            return jQuery.when.apply(jQuery, deferredCalls);
        }).then(function () {
            // Loop through the base products list and build the tiers for each base product (handles only).
            jQuery.each(newBaseProducts, function (handle, data) {
                var productInfo = parseProduct(newProducts[handle]);
                newBaseProducts[handle].tiers = productInfo.tiers;

                // Loop through the base products list and determine what tier needs to be used in the cart, and mark that on the
                // base product.
                var tierList = Object.keys(productInfo.tiers).sort().reverse();
                var tierListLength = tierList.length;
                for (var i = 0; i < tierListLength; i++) {
                    if (!newBaseProducts[handle].hasOwnProperty('useProduct') && parseInt(tierList[i]) <= data.quantity) {
                        newBaseProducts[handle].useProduct = productInfo.tiers[tierList[i]];
                    }

                    if (!newBaseProducts[handle].hasOwnProperty('useSubscriptionProduct') && parseInt(tierList[i]) <= data.subscriptionQuantity) {
                        newBaseProducts[handle].useSubscriptionProduct = productInfo.tiers[tierList[i]];
                    }
                }
            });

            // Loop through the base products list, and any marked tier products that are missing in newProducts, use ajax
            // to get the product data.
            deferredCalls = [];
            jQuery.each(newBaseProducts, function (handle, data) {
                if (data.hasOwnProperty('useProduct') && (!newProducts.hasOwnProperty(data.useProduct) || newProducts[data.useProduct].fetch === true)) {
                    var call = jQuery.ajax({url: '/products/' + data.useProduct, method: 'GET', dataType: 'json'}).then(function (productData) {
                        if (newProducts.hasOwnProperty(productData.product.handle) && newProducts[productData.product.handle].hasOwnProperty('subscriptionProduct')) {
                            productData.product.subscriptionProduct = newProducts[productData.product.handle].subscriptionProduct;
                        }
                        newProducts[productData.product.handle] = productData.product;
                        if (typeof productData.product.tags === 'string') {
                            newProducts[productData.product.handle].tags = productData.product.tags.split(', ');
                        }
                    });
                    deferredCalls.push(call);
                }

                if (data.hasOwnProperty('useSubscriptionProduct') && (!newProducts.hasOwnProperty(data.useSubscriptionProduct) || newProducts[data.useSubscriptionProduct].fetch === true)) {
                    call = jQuery.ajax({url: '/products/' + data.useSubscriptionProduct, method: 'GET', dataType: 'json'}).then(function (productData) {
                        if (newProducts.hasOwnProperty(productData.product.handle) && newProducts[productData.product.handle].hasOwnProperty('subscriptionProduct')) {
                            productData.product.subscriptionProduct = newProducts[productData.product.handle].subscriptionProduct;
                        }
                        newProducts[productData.product.handle] = productData.product;
                        if (typeof productData.product.tags === 'string') {
                            newProducts[productData.product.handle].tags = productData.product.tags.split(', ');
                        }
                    });
                    deferredCalls.push(call);
                }
            });

            return jQuery.when.apply(jQuery, deferredCalls);
        }).then(function () {
            // Loop through the base products list, and any marked tier products that are supposed to be subscription products,
            // check for the handle in the data. If the handle is missing, use ajax to get the handle of the subscription product,
            // and add that to the tier data.
            deferredCalls = [];
            jQuery.each(newBaseProducts, function (handle, data) {
                if (data.hasOwnProperty('useSubscriptionProduct')) {
                    if (newProducts[data.useSubscriptionProduct].hasOwnProperty('subscriptionProduct')) {
                        newBaseProducts[handle].useSubscriptionProduct = newProducts[data.useSubscriptionProduct].subscriptionProduct;
                    } else {
                        var call = jQuery.ajax({url: '/products/' + data.useSubscriptionProduct + '?view=recharge-metafields', method: 'GET', dataType: 'json', headers: {
                                Accept: 'text/html',
                                'Content-Type': 'text/html'
                            }}).then(function (rechargeData) {
                            // this returns the following:
                            // {"product":{"discount_percentage":"10.0000000000","discount_product_id":"1385702096970","has_subscription":"True","is_subscription_only":"false","shipping_interval_frequency":"30","shipping_interval_unit_type":"Days","subscription_id":"60417"},"variants":{"0":{"discount_variant_id":"12422566740042","discount_variant_price":"40.50"}
                            // }}
                            // instead of having an actual handle, useSubscriptionProduct set it as the subscription product id, and immediately add newProducts[subscription product id]
                            // and store the variant information there.
                            newBaseProducts[handle].useSubscriptionProduct = rechargeData.product.discount_product_id;
                            if (!newProducts.hasOwnProperty(data.useSubscriptionProduct)) {
                                newProducts[data.useSubscriptionProduct] = {
                                    fetch: false,
                                    handle: data.useSubscriptionProduct
                                };
                            }
                            newProducts[data.useSubscriptionProduct].subscriptionProduct = rechargeData.product.discount_product_id;
                            newProducts[rechargeData.product.discount_product_id] = {
                                fetch: false,
                                variants: rechargeData.variants
                            };
                        });
                        deferredCalls.push(call);
                    }
                }
            });

            return jQuery.when.apply(jQuery, deferredCalls);
        }).then(function () {
            // Loop through the base products list, and create the list of updated cart products from the marked tier products.
            jQuery.each(newBaseProducts, function (handle, data) {
                if (data.quantity > 0) {
                    newCartProducts[data.useProduct] = data.quantity;
                }

                if (data.subscriptionQuantity > 0) {
                    newCartProducts[data.useSubscriptionProduct] = data.subscriptionQuantity;
                }
            });

            // Loop through the updated cart products, and for any that are missing the product data in the products list, use
            // and ajax call to get the product data.
            deferredCalls = [];
            jQuery.each(newCartProducts, function (handle, quantity) {
                if (!newProducts.hasOwnProperty(handle) || newProducts[handle].fetch === true) {
                    var call = jQuery.ajax({url: '/products/' + handle, method: 'GET', dataType: 'json'}).then(function (productData) {
                        if (newProducts.hasOwnProperty(productData.product.handle) && newProducts[productData.product.handle].hasOwnProperty('subscriptionProduct')) {
                            productData.product.subscriptionProduct = newProducts[productData.product.handle].subscriptionProduct;
                        }
                        newProducts[productData.product.handle] = productData.product;
                        if (typeof productData.product.tags === 'string') {
                            newProducts[productData.product.handle].tags = productData.product.tags.split(', ');
                        }
                    });
                    deferredCalls.push(call);
                }
            });

            return jQuery.when.apply(jQuery, deferredCalls);
        }).then(function () {
            // Loop through the updated cart products, and create the cart update array with ids and quantity changes.
            jQuery.each(newCartProducts, function (handle, quantity) {
                if (newProducts[handle].variants[0].hasOwnProperty('id')) {
                    newCartUpdates[newProducts[handle].variants[0].id] = quantity;
                } else {
                    newCartUpdates[newProducts[handle].variants[0].discount_variant_id] = quantity;
                }
            });

            // Loop through the cart items, and any that don't appear in the cart update array, add to the cart update array with
            // a quantity of 0. Also if the item already has the correct quantity, remove it from the update array.
            jQuery.each(window.ox.cartItems, function (itemId, item) {
                var product = newProducts[item.handle];
                if (product !== null && product !== undefined) {
                    if (!newCartUpdates.hasOwnProperty(product.variants[0].id)) {
                        newCartUpdates[product.variants[0].id] = 0;
                    } else if (newCartUpdates[product.variants[0].id] === item.quantity) {
                        delete newCartUpdates[product.variants[0].id];
                    }
                }
            });

            // Use the cart update array to update the cart.
            if (Object.keys(newCartUpdates).length > 0) {
                return jQuery.ajax({
                    url: '/cart/update.js',
                    data: {updates: newCartUpdates},
                    dataType: 'json',
                    method: 'POST'
                }).then(function () {
                    return true;
                });
            } else {
                return false;
            }
        }).then(function (cartUpdated) {
            // Run the original buildset-v2 logic.
            jQuery.each(window.ox.cartProducts, function (productId, product) {
                if (product.hasOwnProperty('variants')) {
                    var hasDiscount = false;
                    jQuery.each(product.variants, function (variantId, variant) {
                        if (tier1.test(variant.name) || tier2.test(variant.name)) {
                            hasDiscount = true;
                        }
                    });

                    if (!hasDiscount) {
                        delete window.ox.cartProducts[productId];
                    }
                }
            });

            var cartQuantities = {};
            var totalCartQuantities = 0;
            jQuery.each(window.ox.cartItems, function (itemId, item) {
                totalCartQuantities += item.quantity;

                if (window.ox.cartProducts.hasOwnProperty(item.product_id)) {
                    if (!cartQuantities.hasOwnProperty(item.product_id)) {
                        cartQuantities[item.product_id] = 0;
                    }

                    cartQuantities[item.product_id] += item.quantity;
                }
            });

            var currentCartQty = 0;
            var headerCartIndicatorParts;

            jQuery("#StickyBar .header-info .site-header__cart").each(function () {
                if (headerCartIndicatorParts = (jQuery(this).html()).match(/\((.*)\)/)) {
                    currentCartQty = parseFloat(headerCartIndicatorParts.pop());
                }

                if (jQuery(".cart--empty-message").length > 0) {
                    jQuery(this).html((jQuery(this).html()).replace(currentCartQty, 0));
                } else if (!isNaN(currentCartQty)) {
                    jQuery(this).html((jQuery(this).html()).replace(currentCartQty, totalCartQuantities));
                }
            });

            var updates = {};
            var adds = [];

            jQuery.each(window.ox.cartItems, function (itemId, item) {
                if (cartQuantities.hasOwnProperty(item.product_id)) {
                    var newTitle = item.title;
                    if (tier2.test(item.title)) {
                        var matches = tier2.exec(item.title);
                        newTitle = matches[1];
                    } else if (tier1.test(item.title)) {
                        var matches = tier1.exec(item.title);
                        newTitle = matches[1];
                    }

                    if (cartQuantities[item.product_id] >= 6) {
                        if (!tier2.test(item.title)) {
                            newTitle += ' 6+';
                        } else {
                            return;
                        }
                    } else if (cartQuantities[item.product_id] >= 3) {
                        if (!tier1.test(item.title)) {
                            newTitle += ' 3-5';
                        } else {
                            return;
                        }
                    } else if (cartQuantities[item.product_id] >= 0) {
                        if (!tier1.test(item.title) && !tier2.test(item.title)) {
                            return;
                        }
                    }
                    jQuery.each(window.ox.cartProducts[item.product_id].variants, function (variantId, variant) {
                        if (variant.name === newTitle) {
                            if (variant.id === item.id) {
                                updates[variant.id] = item.quantity;
                            } else {
                                adds.push({
                                    id: variant.id,
                                    quantity: item.quantity,
                                    properties: item.properties
                                });
                            }
                        }
                    });

                    if (!updates.hasOwnProperty(item.id)) {
                        updates[item.id] = 0;
                    }
                }
            });

            if (Object.keys(updates).length > 0 || adds.length > 0 || cartUpdated) {
                // Account for being on the cart page itself
                if (jQuery('body.template-cart').length === 0)
                {
                    var oldCallback = callback;
                    callback = function () {
                        window.ox.ajaxcart.load(oldCallback);
                    };
                }
            }

            if (Object.keys(updates).length > 0) {
                jQuery.ajax({
                    url: '/cart/update.js',
                    data: {updates: updates},
                    success: function () {
                        window.ox.ajaxcart.processDiscountCartAdds(adds, callback);
                    },
                    dataType: 'json'
                });
            } else {
                window.ox.ajaxcart.processDiscountCartAdds(adds, callback);
            }
        });
    },

    processDiscountCartAdds: function (adds, callback) {
        if (adds.length > 0) {
            var thisAdd = adds.shift();
            jQuery.ajax({
                url: '/cart/add.js',
                data: thisAdd,
                success: function () {
                    window.ox.ajaxcart.processDiscountCartAdds(adds, callback);
                },
                dataType: 'json'
            });
        } else {
            if (typeof callback === 'function') {
                callback();
            }
        }
    },
    
    updateCart: function() {
        $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
            success: function (response) {
                $('.cart-count').text(response.item_count);
                ox.upsells.triggerCartLoaded(response);
            },
            error: function (error) {
                console.log('Something went wrong', error);
            }
        });
    }
};

jQuery(function () {
    window.ox.ajaxcart.registerEventListeners();
    if (window.location.search.match('ajaxcart=1')) {
        var q = window.location.search.replace(/\&?ajaxcart\=1\&?/, '');
        window.location = '/cart' + q;
    }

    // header nav cart link
    jQuery('a.site-header__cart').click(function (e) {
        e.preventDefault();
        window.ox.ajaxcart.open();
        if (typeof hextom_fsb !== 'undefined')
        {
            hextom_fsb();
        }
    });
});
